export const cleanParams = (params: any) => {
  const cleanedParams = params;

  Object.keys(cleanedParams).forEach((key) => {
    if (
      cleanedParams[key] === undefined ||
      cleanedParams[key] === '' ||
      (Array.isArray(cleanedParams[key]) && cleanedParams[key].length === 0)
    ) {
      delete cleanedParams[key];
    }
  });

  return cleanedParams;
};
